export default "__VITE_ASSET__2202706b__"